var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{saved: _vm.savedFields.hasOwnProperty(_vm.name) && !_vm.changed}},[_c('v-checkbox',{attrs:{"label":_vm.title},on:{"change":function($event){_vm.changed = true}},model:{value:(_vm.item[_vm.name]),callback:function ($$v) {_vm.$set(_vm.item, _vm.name, $$v)},expression:"item[name]"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26350f2d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit-form/Checkbox.vue
// module id = null
// module chunks = 